import { useIsModalOpen } from '@codegouvfr/react-dsfr/Modal/useIsModalOpen';
import React, { PropsWithChildren } from 'react';
import { DsfrModal } from './types/dsfr-modal.type';
import './modal.css';

export const ConfirmationModal = ({
                                    dsfrModal,
                                    title,
                                    description,
                                    subDescription,
                                    confirmProps,
                                    cancelProps,
                                    children,
                                  }: ConfirmationModalProps) => {
  useIsModalOpen(dsfrModal, {
    onConceal: () => cancelProps?.onClick?.(),
  });

  return (
    <dsfrModal.Component title={title ?? ''}
                         size="large"
                         topAnchor={false}
                         iconId="fr-icon-info-line"
                         buttons={[
                           {
                             children: cancelProps?.label ?? 'ANNULER',
                             // className: 'text-red-400!',
                             doClosesModal: true,
                             priority: 'tertiary',
                             disabled: cancelProps?.disabled ?? false,
                             onClick: () => cancelProps?.onClick?.(),
                           },
                           {
                             children: confirmProps.label ?? 'CONFIRMER',
                             doClosesModal: false,
                             priority: 'primary',
                             disabled: confirmProps.disabled ?? false,
                             onClick: () => confirmProps.onClick?.(),
                           },
                         ]}>
      <div>
        <p>{description}</p>
        <p>{subDescription}</p>
      </div>
      {children}
    </dsfrModal.Component>
  );
};

export interface ConfirmationModalProps extends PropsWithChildren {
  dsfrModal: DsfrModal;
  data?: any;
  title?: string;
  description?: string;
  subDescription?: string;
  confirmProps: ButtonProps;
  cancelProps?: ButtonProps;
}

interface ButtonProps {
  label?: string;
  onClick?: () => void;
  disabled?: boolean;
}